module.exports = {
  "zones": {
    "Africa/Accra": ["z", {
      "wallclock": -1640995200000,
      "format": "GMT/+0020",
      "abbrev": "GMT",
      "offset": 0,
      "posix": -1640995148000,
      "save": 0,
      "rules": "Ghana"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -52000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Ghana": [{
      "from": 1920,
      "to": 1942,
      "month": 8,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 20,
      "letter": "",
      "saved": 0
    }, {
      "from": 1920,
      "to": 1942,
      "month": 11,
      "day": [7, 31],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 1200000
    }]
  }
};